























































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import AccordionSelect from '@/components/AccordionSelect.vue'
import Input from '@/components/inputs/Input.vue'
import Confirm from '@/components/Confirm.vue'
import { TemplateModule } from '@/store/modules/template.module'
import { FacilityModule } from '@/store/modules/facility.module'
import FlowItem from '@/views/app/management/components/FlowItem.vue'
import {
  ECollectionFlowActions,
  ETemplateType,
  EUserPermissions,
  ICollectionFlow,
  IFacility,
  IPayerType
} from '@zunta/configurations'

import { IAccoridionElementItem } from '@/interfaces'

import Api from '@/api'
import { User } from '@/classes/User'
import GoBack from '@/components/GoBack.vue'
import Card from '@/components/Card.vue'

const uniqBy = require('lodash.uniqby')

@Component({
  name: 'CreateBillingFlow',
  components: {
    Card,
    GoBack,
    Icon,
    Input,
    Checkbox,
    AccordionSelect,
    FlowItem,
    ErrorMessages,
    Confirm
  }
})
export default class CreateBillingFlow extends Vue {
  collectionFlowName: string = 'Default'
  collectionFlowAmount: number | null = null
  errors: string[] = []
  additionalFlows: any[] = []
  reloadFlows: boolean = false
  reloadPayerTypes: boolean = false
  ECollectionFlowActions: any = ECollectionFlowActions
  selectedPayerTypes: IPayerType[] = []
  payerTypeToSelect: IPayerType | null = null
  shouldConfirmChangePayerType: boolean = false
  showSaveFlowPopup: boolean = false
  disabledActionNames: string[] = []
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  requiredFlows: any[] = [{
    flowAction: ECollectionFlowActions.CHANGE_STATUS_TO_DUE,
    actions: [],
    timeframe: 10
  }, {
    flowAction: ECollectionFlowActions.CHANGE_STATUS_TO_OVERDUE,
    actions: [],
    timeframe: 30
  }, {
    flowAction: ECollectionFlowActions.CHANGE_STATUS_TO_DELINQUENT,
    actions: [],
    timeframe: 60
  }]
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)

  get facilityId () {
    return this.$route.params.id
  }

  get collectionFlowId () {
    return this.$route.params.collectionFlowId
  }

  get allCollectionFlows () {
    return this.$store.state.facility.collectionFlows
  }

  get copyCollectionFlowItems () {
    return this.allFacilities.map((facility: IFacility) => {
      const facilityCollectionFlows = this.allCollectionFlows.filter((collectionFlow: ICollectionFlow) => collectionFlow.facility === facility.id)
      if (facilityCollectionFlows.length === 0) {
        return null
      }
      return {
        title: facility.name,
        items: facilityCollectionFlows.map((collectionFlow: ICollectionFlow) => ({
          key: collectionFlow.id,
          value: collectionFlow.id,
          content: collectionFlow.flowName
        }))
      }
    }).filter(Boolean)
  }

  get allFacilities () {
    return this.$store.state.facility.facilities
  }

  get isNew () {
    return this.collectionFlowId === 'new'
  }

  get facility () {
    return this.$store.state.facility.selectedFacility
  }

  get payerTypes () {
    return this.$store.state.facility.payerTypes
  }

  get activePayerTypes () {
    return this.payerTypes.filter((payerType: IPayerType) => payerType.active)
  }

  get selectedCollectionFlowData () {
    return this.$store.state.facility.selectedCollectionFlowData
  }

  get isAllPayersTypesSelected () {
    return this.activePayerTypes.length === this.selectedPayerTypes.length
  }

  async mounted () {
    if (!this.facility) {
      await this.facilityModuleInstance.getFacility(this.facilityId)
    }
    await this.facilityModuleInstance.fetchPayerTypes(this.facilityId)
    await this.facilityModuleInstance.getFacilityList({})
    await this.facilityModuleInstance.fetchAllCollectionFlows()
    await this.templateModuleInstance.fetchTemplates({})
    if (!this.isNew) {
      this.initByCollectionFlow(this.collectionFlowId)
    }
    this.listenNewTemplateAddedEvent = this.listenNewTemplateAddedEvent.bind(this)
    window.addEventListener('storage', this.listenNewTemplateAddedEvent, false)
  }

  async listenNewTemplateAddedEvent (event: any) {
    if (event.storageArea === localStorage) {
      if (event.key === 'new-template') {
        await this.templateModuleInstance.fetchTemplates({})
      }
    }
  }

  async initByCollectionFlow (id: number | string, shouldCopyPayerTypes: boolean = true) {
    await this.facilityModuleInstance.getCollectionFlowById(id)
    if (this.selectedCollectionFlowData) {
      this.collectionFlowName = this.selectedCollectionFlowData.collectionFlowName
      this.collectionFlowAmount = this.selectedCollectionFlowData.collectionFlowAmount
      this.requiredFlows = this.selectedCollectionFlowData.flows.filter((flow: any) => (
        ![
          ECollectionFlowActions.NONE,
          ECollectionFlowActions.ADD_TO_COLLECTION,
          ECollectionFlowActions.CHANGE_STATUS_TO_WRITTEN_OFF,
          ECollectionFlowActions.CHANGE_STATUS_TO_WRITTEN_OFF_AND_CEASE_COLLECTIONS
        ].includes(flow.flowAction)
      )).sort((a: any, b: any) => a.timeframe - b.timeframe)
      const initSpecialAction = (allFlows: any[], templateIdLabel: string, tamplateLabel: string, action: ECollectionFlowActions) => {
        const flow = this.selectedCollectionFlowData.flows.find((flow: any) => {
          return flow.flowAction === action
        })
        if (flow) {
          const destinationFlow = allFlows.find((selectedflow: any) => {
            return selectedflow.timeframe === flow.timeframe
          })
          if (destinationFlow) {
            this.disabledActionNames.push(templateIdLabel)
            destinationFlow.actions.unshift({
              template: templateIdLabel,
              templateName: tamplateLabel
            })
          }
        }
      }

      this.requiredFlows.forEach((flow: any) => {
        flow.actions = flow.actions.sort((a: any, b: any) => a.order - b.order)
      })

      this.additionalFlows = this.selectedCollectionFlowData.flows.filter((flow: any) => (
        flow.flowAction === ECollectionFlowActions.NONE
      )).sort((a: any, b: any) => a.timeframe - b.timeframe)
      this.additionalFlows.forEach((flow: any) => {
        flow.actions = flow.actions.sort((a: any, b: any) => a.order - b.order)
      })
      const allFlows = [...this.requiredFlows, ...this.additionalFlows]
      initSpecialAction(allFlows, 'add-to-collection', 'Add To Collection', ECollectionFlowActions.ADD_TO_COLLECTION)
      initSpecialAction(allFlows, 'write-off-and-cease-collections', 'Write Off And Cease Collections', ECollectionFlowActions.CHANGE_STATUS_TO_WRITTEN_OFF_AND_CEASE_COLLECTIONS)
      initSpecialAction(allFlows, 'write-off', 'Write Off Only', ECollectionFlowActions.CHANGE_STATUS_TO_WRITTEN_OFF)
      if (shouldCopyPayerTypes) {
        this.selectedPayerTypes = this.selectedCollectionFlowData.payerTypes
      }
      this.reloadFlows = true
      this.$nextTick(() => {
        this.reloadFlows = false
      })
    }
  }

  initDisabledActions () {
    this.disabledActionNames = []
    this.requiredFlows.concat(this.additionalFlows).forEach((flow: any) => {
      flow.actions.forEach((action: any) => {
        if ([
          'add-to-collection',
          'write-off',
          'write-off-and-cease-collections'
        ].includes(action.template)) {
          this.disabledActionNames.push(action.template)
        }
      })
    })
  }

  beforeDestroy () {
    this.facilityModuleInstance.resetSelectedCollectionFlowData()
    window.removeEventListener('storage', this.listenNewTemplateAddedEvent, false)
  }

  goBack () {
    this.$router.push({
      name: 'management-facilities-settings-collections-management',
      params: { id: this.facility.id }
    })
  }

  toggleAllPayerTypes (selectAllPayers: boolean) {
    if (selectAllPayers) {
      this.selectedPayerTypes = JSON.parse(JSON.stringify(this.activePayerTypes))
    } else {
      this.selectedPayerTypes = []
    }
  }

  togglePayerType (payerType: IPayerType, force: boolean = false) {
    if (this.isPayerTypeSelected(payerType)) {
      this.selectedPayerTypes = this.selectedPayerTypes.filter((sPayerType: IPayerType) => (
        sPayerType.id !== payerType.id
      ))
    } else {
      if (!force) {
        if (payerType.collectionFlow && (payerType.collectionFlow as ICollectionFlow).id.toString() !== this.collectionFlowId) {
          this.payerTypeToSelect = payerType
          this.shouldConfirmChangePayerType = true
          return
        }
      } else {
        this.payerTypeToSelect = null
        this.shouldConfirmChangePayerType = false
      }
      delete payerType.collectionFlow
      this.selectedPayerTypes.push(payerType)
    }
  }

  closeConfirmChangePayerTypeModal () {
    this.shouldConfirmChangePayerType = false
    this.payerTypeToSelect = null
    this.reloadPayerTypes = true
    this.$nextTick(() => {
      this.reloadPayerTypes = false
    })
  }

  isPayerTypeSelected (payerType: IPayerType) {
    return !!this.selectedPayerTypes.find((sPayerType: IPayerType) => (
      sPayerType.id === payerType.id
    ))
  }

  copyCollectionFlow (item: IAccoridionElementItem) {
    this.initByCollectionFlow(item.value, false)
  }

  addNewFlow () {
    this.additionalFlows.push({ timeframe: 101, actions: [], flowAction: ECollectionFlowActions.NONE })
  }

  changeRequiredFlow (index: number, flowItem: any) {
    this.requiredFlows[index] = flowItem
    this.initDisabledActions()
    if (!flowItem.silent) {
      this.reloadFlows = true
      this.$nextTick(() => {
        this.reloadFlows = false
      })
    }
  }

  changeAdditionalFlow (index: number, flowItem: any) {
    this.additionalFlows[index] = flowItem
    this.initDisabledActions()
    if (!flowItem.silent) {
      this.reloadFlows = true
      this.$nextTick(() => {
        this.reloadFlows = false
      })
    }
  }

  validate () {
    this.errors = []
    this.$eventBus.$emit('Input:validate')
    if (!this.collectionFlowName) {
      this.errors.push('Flow Name is Required')
    }
    const requireFlowsTimeFrames = [...this.requiredFlows, ...this.additionalFlows]
      .filter((flow: any) => flow.flowAction !== ECollectionFlowActions.ADD_TO_COLLECTION)
      .map((flow: any) => flow.timeframe)
    if (requireFlowsTimeFrames.slice().sort((a, b) => a - b).join() !== requireFlowsTimeFrames.join()) {
      this.errors.push('The number of days in each row must increment')
    }
    const allFlows = this.requiredFlows.filter((flow: any) => {
      return flow.flowAction !== ECollectionFlowActions.ADD_TO_COLLECTION
    }).concat(this.additionalFlows)
    if (allFlows.length !== uniqBy(allFlows, 'timeframe').length) {
      this.errors.push('There are 2 rows with the same Number of days, Please adjsut.')
    }
    if (!this.disabledActionNames.includes('add-to-collection')) {
      this.errors.push('You must choose "Add to Collections" action')
    }
    return this.errors.length === 0
  }

  async handleCreateTemplate (event: { type: ETemplateType }) {
    const goSetupTemplate = () => {
      const resolvedPath: any = this.$router.resolve({
        name: 'management-template',
        params: {
          templateId: 'new'
        },
        query: {
          type: event.type,
          backUrl: `/app/management/settings/facilities/${this.facilityId}/collections-management/create-billing-flow/${this.collectionFlowId}`
        }
      })
      this.$locationManager.openNewTab(resolvedPath.href)
    }
    goSetupTemplate()
  }

  closeSaveFlowPopup () {
    this.showSaveFlowPopup = false
  }

  // removeRequiredFlows (index: any) {
  //   this.requiredFlows.splice(index, 1)
  // }

  removeAdditionalFlows (index: any) {
    this.additionalFlows.splice(index, 1)
  }

  async save () {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_COLLECTIONS_FLOW)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: 'Modify Collection Flow',
        icon: 'warning'
      })
      return
    }
    if (this.validate()) {
      let header
      let message
      let isSuccess = true
      const getFlowData = () => {
        const flows = this.requiredFlows.concat(this.additionalFlows)
        const initSpecialFlow = (templateIdLabel: string, status: ECollectionFlowActions) => {
          for (let i = 0; i < flows.length; i++) {
            const flow = flows[i]
            const action = flow.actions.find((action: any) => action.template === templateIdLabel)
            if (action) {
              flows.push({
                flowAction: status,
                timeframe: flow.timeframe,
                actions: []
              })
            }
          }
        }
        initSpecialFlow('add-to-collection', ECollectionFlowActions.ADD_TO_COLLECTION)
        initSpecialFlow('write-off-and-cease-collections', ECollectionFlowActions.CHANGE_STATUS_TO_WRITTEN_OFF_AND_CEASE_COLLECTIONS)
        initSpecialFlow('write-off', ECollectionFlowActions.CHANGE_STATUS_TO_WRITTEN_OFF)
        return {
          collectionFlowName: this.collectionFlowName,
          collectionFlowAmount: this.collectionFlowAmount ? this.collectionFlowAmount : 0,
          flows: flows.map((flow: any) => ({
            ...flow,
            actions: flow.actions.filter((action: any) => ![
              null,
              undefined,
              'write-off',
              'write-off-and-cease-collections',
              'add-to-collection'
            ].includes(action.template))
          })),
          payerTypes: this.selectedPayerTypes
        }
      }
      if (this.isNew) {
        const collectionFlow = await this.facilityModuleInstance.createCollectionFlow({
          facilityId: this.facilityId,
          data: getFlowData()
        })
        header = 'Create Collection Flow'
        if (!collectionFlow.id) {
          isSuccess = false
          message = 'Something went wrong'
        } else {
          message = 'Collection Flow successfully created!'
        }
        this.$router.push({
          name: 'management-facilities-create-billing-flow',
          params: {
            facilityId: this.facilityId,
            collectionFlowId: collectionFlow.id.toString()
          }
        })
      } else {
        const response = await this.facilityModuleInstance.updateCollectionFlow({
          collectionFlowId: this.collectionFlowId,
          data: getFlowData()
        })
        header = 'Update Collection Flow'
        if (response === 'OK') {
          message = 'Collection Flow successfully updated!'
        } else {
          isSuccess = false
          message = 'Something went wrong'
        }
      }
      this.$eventBus.$emit('notify', {
        color: isSuccess ? 'var(--status-success-color)' : 'var(--status-error-color)',
        message: message,
        header: header,
        icon: isSuccess ? 'check' : 'warning'
      })
    }
  }
}
